import domainRepository from '@/api/domainRepository';
import { MessageStateType } from '@/types/message/state.type';
import { IDomain, IBmsDomain } from './../../models/domain.model';

export let domain: IDomain;
export let bms: IBmsDomain;
export let domainEndpoint: string = 'domain/' + process.env.VUE_APP_DOMAINID;
export let bmsAppEndpoint: string;

export function fetchDomainConfig(): Promise<void> {
  return new Promise((resolve, reject) => {
    domainRepository
      .getDomainConfig()
      .then(domainResponse => {
        domain = domainResponse;
        domainEndpoint = 'domain/' + domainResponse.id;
        domainRepository
          .getBmsDomainConfig()
          .then(bmsResponse => {
            bms = bmsResponse;
            bmsAppEndpoint = 'bmsapp/' + bmsResponse.appid;
            resolve();
          })
          .catch(e => reject(e));
      })
      .catch(e => reject(e));
  });
}

export function hasDomainMessageState(state: MessageStateType): boolean {
  return bms.bms_settings.admin_widget.available_statuses
    .map(availableStates => availableStates.name_en)
    .includes(state);
}
